module.exports = __webpack_public_path__ + "static/ks-collect/img/order-coin.1b4ed77d.png";